import Heading from 'components/heading/Heading';

import { IDescriptionListBlock } from 'source/NFR.types';

const DescriptionListBlock: React.FC<IDescriptionListBlock> = ({ headingLevel = 2, items = [], title }) => (
  <div className="description-list-block">
    {title && (
      <Heading className="description-list-block--title" level={headingLevel}>
        {title}
      </Heading>
    )}

    <dl className="description-list-block">
      {items?.map(item => (
        <span key={item.label + item.text}>
          <dt>{item.label}</dt>
          <dd>{item.text}</dd>
        </span>
      ))}
    </dl>
  </div>
);

DescriptionListBlock.displayName = 'DescriptionListBlock';

export default DescriptionListBlock;
